import styled from '@emotion/styled';
import { Tooltip } from '@kc-console/common-ui';
import { getUserGuidePath, useScopedLinkBuilder } from '@kc-console/context';
import { useTranslation } from '@kc-console/core';
import IcUserguideRegular from '@kep/kcds-icons/IcUserguideRegular';

import GnbIconButton from './GnbIconButton';

const GuideMenuLinkContainer = styled('a')(({ theme }) => ({
  position: 'relative',
  ...theme.mixins.focusRing('inside', { inverse: true }),
}));

const GuideMenu = () => {
  const { t } = useTranslation();
  const { getProps } = useScopedLinkBuilder();
  const docsUrl = getUserGuidePath('start');

  return (
    <Tooltip message={t('layout:gnb.guide.navigate_msg')}>
      <GuideMenuLinkContainer
        {...getProps(docsUrl, { external: true })}
        aria-label={t('common:common.link.user_guide')}
      >
        <GnbIconButton disableRipple tabIndex={-1} aria-label={t('common:common.link.user_guide')}>
          <IcUserguideRegular />
        </GnbIconButton>
      </GuideMenuLinkContainer>
    </Tooltip>
  );
};

export default GuideMenu;
